import { render, staticRenderFns } from "./Avaliacao.vue?vue&type=template&id=40c2d576"
import script from "./Avaliacao.vue?vue&type=script&lang=js"
export * from "./Avaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports